import SelectionStatus from 'portfolio/components/SelectionStatus';
import React from 'react';

import OpenSubmissionsSettings from 'widgets/openSubmissions/toolbar/OpenSubmissionsSettings';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import './OpenSubmissionsToolbar.scss';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { GridExportButton } from '@instinet-analytics/semantic-ui-components';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

interface OpenSubmissionsToolbarProps {
    widgetKey: string;
    widgetHeight: number;
    showChart: boolean;
    showGrid: boolean;
    hovering: boolean;
    gridApi?: GridApi;
}

export default function OpenSubmissionsToolbar(
    props: OpenSubmissionsToolbarProps
) {
    const { widgetKey, showGrid, gridApi } = props;

    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const { editedColumnNames } = useWidgetEditedColumnNames();

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection}>
            <div className="OpenSubmissionsToolbar panel-header">
                {!hasValidSelection && (
                    <div className="toolbar">
                        <SelectionStatus
                            widgetName="Open Submissions Widget"
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                        />
                    </div>
                )}

                <WidgetToolbar
                    settingsHeader="Open Submissions Settings"
                    settingsBody={
                        <OpenSubmissionsSettings widgetKey={widgetKey} />
                    }
                    fixedItems={
                        hasValidSelection && showGrid ? (
                            <GridExportButton
                                csvFileName="Open Submissions"
                                gridApi={gridApi}
                                editedColumnNames={editedColumnNames}
                            />
                        ) : undefined
                    }
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
